import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalformComponent } from './modalform.component';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';



@NgModule({
    imports: [
        BadgeModule,
        ButtonModule,
        CommonModule,
        TooltipModule,
        ModalformComponent
    ],
    exports: [ModalformComponent]
})
export class ModalformModule { }
